import React from 'react';
import Box from '@mui/material/Box';

const SmallHeaderPage = ({children}) => {

    return(

        <Box
        sx={{
          width: '100%',
          marginBottom: 1,
          display: { xs: 'flex', sm: 'flex', md: 'none', lg: 'none', xl: 'none' },
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >

        {children}

      </Box>

    );
};

export default SmallHeaderPage;